import { Box } from '@chakra-ui/react'

import TrialflareIcon from '@/images/icons/trialflare2.png'
import TickIcon from '@/images/icons/tick.png'
import FilesIcon from '@/images/icons/files.png'
import FormIcon from '@/images/icons/form.png'
import DataIcon from '@/images/icons/data.png'
import QuestionIcon from '@/images/icons/question.png'
import PeopleIcon from '@/images/icons/people.png'
import BoxIcon from '@/images/icons/box.png'
import InfoIcon from '@/images/icons/info.png'
import WarningIcon from '@/images/icons/warning.png'
import NotFoundIcon from '@/images/icons/notfound.png'
import MessagesIcon from '@/images/icons/messages.png'
import SiteIcon from '@/images/icons/site.png'
import ResearchIcon from '@/images/icons/research.png'
import ChartIcon from '@/images/icons/chart.png'
import PackIcon from '@/images/icons/pack.png'
import VideoCallIcon from '@/images/icons/videocall.png'
import CogIcon from '@/images/icons/cog.png'
import RobotIcon from '@/images/icons/robot.png'
import JigsawIcon from '@/images/icons/jigsaw.png'
import LockIcon from '@/images/icons/lock.png'
import SignatureIcon from '@/images/icons/signature.png'
import WatchIcon from '@/images/icons/watch.png'
import TimelineIcon from '@/images/icons/timeline.png'
import LogsIcon from '@/images/icons/logs.png'
import NotesIcon from '@/images/icons/notes.png'
import GroupBubblesIcon from '@/images/icons/groupbubbles.png'
import WipIcon from '@/images/icons/wip.png'
import ChecklistIcon from '@/images/icons/checklist.png'
import KeysIcon from '@/images/icons/keys.png'
import DownloadIcon from '@/images/icons/download.png'
import MfaIcon from '@/images/icons/mfa.png'
import DashboardIcon from '@/images/icons/dashboard.png'
import WalletIcon from '@/images/icons/wallet.png'
import GiftcardIcon from '@/images/icons/giftcard.png'

const ICON_MAP = {
  trialflare: TrialflareIcon,
  tick: TickIcon,
  files: FilesIcon,
  form: FormIcon,
  data: DataIcon,
  question: QuestionIcon,
  people: PeopleIcon,
  box: BoxIcon,
  info: InfoIcon,
  warning: WarningIcon,
  notfound: NotFoundIcon,
  messages: MessagesIcon,
  site: SiteIcon,
  research: ResearchIcon,
  chart: ChartIcon,
  pack: PackIcon,
  videocall: VideoCallIcon,
  cog: CogIcon,
  robot: RobotIcon,
  jigsaw: JigsawIcon,
  lock: LockIcon,
  signature: SignatureIcon,
  watch: WatchIcon,
  timeline: TimelineIcon,
  logs: LogsIcon,
  notes: NotesIcon,
  groupbubbles: GroupBubblesIcon,
  wip: WipIcon,
  checklist: ChecklistIcon,
  keys: KeysIcon,
  download: DownloadIcon,
  mfa: MfaIcon,
  dashboard: DashboardIcon,
  wallet: WalletIcon,
  giftcard: GiftcardIcon
}

const ImageIcon = ({ title, iconKey, size, p }) => {
  return (
    <Box
      p={p || 3}
      rounded='md'
      bg='bg.muted'
      borderWidth='2px'
      borderColor='border.emphasized'
    >
      <img alt={title} src={ICON_MAP[iconKey]} style={{ height: size || 50, width: size || 50 }} />
    </Box>
  )
}

export default ImageIcon
